import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import Navigation from './Navigation';
import { withTranslation } from 'react-i18next';

export class Toolbar extends Component {
  toggleActionsBodyClass() {
    document.body.classList.toggle('toolbar-actions-open');
  }

  render() {
    const { t } = this.props;
    return (
      <div className="toolbar">
        <div className="toolbar-inner">
          <div className="logo">
            <NavLink to="/">
              <img
                src={process.env.PUBLIC_URL + window.configs.TOOLBAR_LOGO}
                alt="Logo"
              />
            </NavLink>
          </div>

          <ul className="top"></ul>

          <Navigation />

          <ul className="bottom">
            <li>
              <NavLink to="/login" title={t('Log Off')}>
                <i className="md-icon">power_settings_new</i>
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default withTranslation('app')(Toolbar);
